import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";
import {} from "./utils/utils";
import { SnackbarProvider, MaterialDesignContent } from "notistack";
import { CloseRounded, WarningAmber } from "@mui/icons-material";
import Routes from "./Routes";
import PostHogPageviewTracker from "./components/PostHugPageviewTracker";
import { styled } from "@mui/material/styles";
import Auth from "./components/Auth";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { ThemeSettingsProvider } from "./theme/ThemeSettingsProvider";

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  "&.notistack-MuiContent-warning": {
    backgroundColor: "#EF6C00",
  },
  "&.notistack-MuiContent-info": {
    backgroundColor: "#0288D1",
  },
}));

function App() {
  let snackbarRef = null;

  return (
    <ThemeSettingsProvider>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <SnackbarProvider
          Components={{
            warning: StyledMaterialDesignContent,
            info: StyledMaterialDesignContent,
          }}
          iconVariant={{
            warning: <WarningAmber fontSize="small" sx={{ marginRight: 1 }} />,
          }}
          maxSnack={1}
          ref={(ele) => {
            snackbarRef = ele;
          }}
          onClose={(event, reason, key) => {
            if (reason === "clickaway") {
              snackbarRef.closeSnackbar(key);
            }
          }}
          action={(snackbarId) => (
            <CloseRounded
              onClick={() => snackbarRef.closeSnackbar(snackbarId)}
              fontSize="small"
              style={{ cursor: "pointer" }}
            />
          )}
          autoHideDuration={3000}
          anchorOrigin={{
            horizontal: "center",
            vertical: "top",
          }}>
          <Router>
            <Auth>
              <PostHogPageviewTracker />
              <Routes />
            </Auth>
          </Router>
        </SnackbarProvider>
      </LocalizationProvider>
    </ThemeSettingsProvider>
  );
}

export default App;
